/**
 * Composant KPIs pour la page Satisfaction
 * Affiche les 4 cartes de statistiques principales
 */

import { Card, CardContent } from '../../components/ui/card';
import { TrendingUp, GraduationCap, Star, CheckCircle } from 'lucide-react';

export const SatisfactionKPIs = ({ stats }) => {
  if (!stats) return null;

  return (
    <div className="grid grid-cols-1 md:grid-cols-4 gap-4" data-testid="satisfaction-kpis">
      <Card>
        <CardContent className="p-4">
          <div className="flex items-center gap-3">
            <div className="p-3 bg-green-100 rounded-full">
              <TrendingUp className="h-6 w-6 text-green-600" />
            </div>
            <div>
              <p className="text-sm text-slate-500">Taux d'insertion</p>
              <p className="text-2xl font-bold text-green-600">{stats?.insertion?.taux_insertion || 0}%</p>
            </div>
          </div>
        </CardContent>
      </Card>
      
      <Card>
        <CardContent className="p-4">
          <div className="flex items-center gap-3">
            <div className="p-3 bg-blue-100 rounded-full">
              <GraduationCap className="h-6 w-6 text-blue-600" />
            </div>
            <div>
              <p className="text-sm text-slate-500">Diplômés</p>
              <p className="text-2xl font-bold text-blue-600">{stats?.insertion?.total || 0}</p>
            </div>
          </div>
        </CardContent>
      </Card>
      
      <Card>
        <CardContent className="p-4">
          <div className="flex items-center gap-3">
            <div className="p-3 bg-amber-100 rounded-full">
              <Star className="h-6 w-6 text-amber-600" />
            </div>
            <div>
              <p className="text-sm text-slate-500">Taux de réponse</p>
              <p className="text-2xl font-bold text-amber-600">{stats?.questionnaires?.taux_reponse || 0}%</p>
            </div>
          </div>
        </CardContent>
      </Card>
      
      <Card>
        <CardContent className="p-4">
          <div className="flex items-center gap-3">
            <div className="p-3 bg-purple-100 rounded-full">
              <CheckCircle className="h-6 w-6 text-purple-600" />
            </div>
            <div>
              <p className="text-sm text-slate-500">Questionnaires</p>
              <p className="text-2xl font-bold text-purple-600">
                {stats?.questionnaires?.completes || 0}/{stats?.questionnaires?.total || 0}
              </p>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default SatisfactionKPIs;
